module.exports = __webpack_public_path__ + "img/nadia.37f06e3a.png";